/**
 * <s-product-gallery>: one main image track (swipe or scroll-snap) with
 * prev/next and thumbnail buttons that invoke it through commands:
 * `--prev`, `--next`, and `--go` (reads data-index from the invoking button).
 */
class SProductGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gallery-track]');
    if (!this.track) return;
    this.slides = Array.from(this.track.children);
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.index = 0;

    this.handleCommand = (event) => {
      const command = event.command;
      if (command === '--next') this.go(this.index + 1);
      else if (command === '--prev') this.go(this.index - 1);
      else if (command === '--go') this.go(Number(event.source?.dataset.index || 0));
    };
    this.addEventListener('command', this.handleCommand);

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
        }
      },
      { root: this.track, threshold: 0.6 }
    );
    this.slides.forEach((slide) => this.observer.observe(slide));
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.handleCommand);
    this.observer?.disconnect();
  }

  go(target) {
    const count = this.slides.length;
    if (!count) return;
    const next = (target + count) % count;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: this.slides[next].offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    this.setActive(next);
  }

  setActive(index) {
    if (index < 0) return;
    this.index = index;
    this.thumbs.forEach((thumb, i) => {
      if (i === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', SProductGallery);
